// extracted by mini-css-extract-plugin
export default {"socialLoginButton":"rMnGrbZzVEZbHEPU0_IQ"};